import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Maximize, X } from "lucide-react";
import { useEvent } from "@/context/EventContext";
import { api, adminHeaders, assetUrl } from "@/lib/api";

export default function Slideshow() {
  const { event } = useEvent();
  const [items, setItems] = useState([]);
  const [i, setI] = useState(0);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    const load = () => api.get("/creations", { headers: adminHeaders() }).then((r) => setItems(r.data.items)).catch((e) => e?.response?.status === 401 && setDenied(true));
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setI((x) => (x + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);

  const current = items[i % Math.max(items.length, 1)];
  const logo = assetUrl(event?.assets?.logo);

  return (
    <div className="app-bg grain flex h-screen flex-col overflow-hidden" data-testid="slideshow-page">
      <div className="absolute left-4 top-4 z-30 flex gap-2">
        <Link to="/admin" className="btn btn-ghost btn-icon" aria-label="Kapat" data-testid="slideshow-close-button"><X size={16} /></Link>
        <button className="btn btn-ghost btn-icon" onClick={() => document.documentElement.requestFullscreen?.()} aria-label="Tam ekran" data-testid="slideshow-fullscreen-button"><Maximize size={16} /></button>
      </div>
      {logo && <img src={logo} alt="" className="absolute right-5 top-5 z-30 h-9 rounded-md bg-white/90 px-2 py-1" />}
      <main className="relative z-10 flex flex-1 items-center justify-center p-6">
        {denied && <p className="glass p-6 text-slate-300" data-testid="slideshow-denied">PIN gerekli. <Link to="/admin" className="text-[var(--accent-soft)] underline">Giriş yap</Link></p>}
        {!denied && !current && <p className="text-slate-400" data-testid="slideshow-empty">Henüz karikatür yok — ilk çekim bekleniyor.</p>}
        <AnimatePresence mode="wait">
          {current && (
            <motion.img
              key={current.id}
              src={current.frame_url}
              alt=""
              className="instax max-h-full p-2 object-contain"
              style={{ maxHeight: "calc(100vh - 120px)" }}
              initial={{ opacity: 0, scale: 0.94, rotate: -1.5 }}
              animate={{ opacity: 1, scale: 1, rotate: 0 }}
              exit={{ opacity: 0, scale: 1.04 }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              data-testid="slideshow-image"
            />
          )}
        </AnimatePresence>
      </main>
    </div>
  );
}
